/* eslint-disable arrow-body-style */
import debounce from 'lodash/debounce';

import {useCallback, useEffect, useState} from 'react';

const resetTyping = debounce((setIsTyping: (isTyping: boolean) => void) => {
  setIsTyping(false);
}, 5_100);

export function useTypingState() {
  const [isTyping, setIsTyping] = useState(false);

  const acknowledgeTyping = useCallback(() => {
    setIsTyping(true);
    resetTyping(() => setIsTyping(false));
  }, []);

  const resetTypingManual = useCallback(() => {
    setIsTyping(false);
    resetTyping.cancel();
  }, []);

  useEffect(function cancelTypingResetOnUnmount() {
    return () => {
      resetTyping.cancel();
    };
  }, []);

  return {
    isTyping,
    acknowledgeTyping,
    resetTypingManual,
  };
}
